import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import Navbar from "@/components/Navbar";
import AIAssistant from "@/components/AIAssistant";
import VisualSearch from "@/components/VisualSearch";
import AuthDialog from "@/components/AuthDialog";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Orders from "@/pages/Orders";
import PaymentSuccess from "@/pages/PaymentSuccess";

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <div className="min-h-screen grain" data-testid="app-root">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/shop/:category" element={<Shop />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
            </Routes>
          </main>
          <footer className="border-t border-black/10 mt-24">
            <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
              <div>
                <div className="font-display font-black text-xl tracking-tighter">NOVA/MARKET</div>
                <div className="font-mono-brand text-[10px] uppercase tracking-[0.3em] text-neutral-500 mt-1">
                  ai-native retail // v1.0
                </div>
              </div>
              <div className="font-mono-brand text-[10px] uppercase tracking-[0.3em] text-neutral-500">
                © 2026 Nova Market — All items are demonstrations.
              </div>
            </div>
          </footer>
          <AIAssistant />
          <VisualSearch />
          <AuthDialog />
          <Toaster
            position="bottom-left"
            toastOptions={{
              className: "rounded-none border border-black/10 font-mono-brand text-xs uppercase tracking-widest",
            }}
          />
        </div>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
